import React, { useContext, useEffect } from "react";
import { Typography } from "@material-tailwind/react";
import RecipesCard from "./Cards/Card";
import DefaultPagination from "./Pagination";
import { RecepiesContext } from "../context/RepiesContext";
import SearchBox from "./SearchBox";
import recipes from "../API/recipes";

const SESSION_KEY = "sessionRecepies";

const SearchResult = () => {
    const { recepies, setRecepies } = useContext(RecepiesContext);

    // On mount: reuse last results for the session (Option 1).
    // If none cached, fetch once and cache them in sessionStorage.
    useEffect(() => {
        try {
            const cached = sessionStorage.getItem(SESSION_KEY);
            if (cached) {
                const data = JSON.parse(cached);
                setRecepies(data);
                return;
            }
        } catch (e) {
            console.warn("Failed to read session cache:", e);
        }

        recipes
            .getRecepies({ number: 20 }) // sort=random handled in recipes.js
            .then((res) => {
                setRecepies(res.data);
                try {
                    sessionStorage.setItem(SESSION_KEY, JSON.stringify(res.data));
                } catch (e) {
                    console.warn("Failed to write session cache:", e);
                }
            })
            .catch((err) => console.error("Failed to fetch recipes:", err));
    }, [setRecepies]);

    return (
        <section className="mx-auto w-full max-w-screen-2xl px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <Typography id="search-section" className="text-2xl font-semibold tracking-tight">
                    Recipes for you
                </Typography>
                <SearchBox />
            </div>

            <div className="mt-6 grid gap-6 min-[420px]:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {recepies.results?.map(({ id, title, image }) => (
                    <RecipesCard key={id} title={title} id={id} image={image} />
                ))}
            </div>

            <div className="mx-auto mt-8 w-max">
                <DefaultPagination {...recepies} />
            </div>
        </section>
    );
};

export default SearchResult;
